<template>
   <div class="page">
     <page-header ></page-header>
     
     <div class="banners">
       <div class="main">
         <div class="containt-div">
              <div class="baner-01-a">
                <div class="caption">
                  <div class="tit">闲逸棋牌全新版本震撼来袭！</div>
                  <div class="txt">来就送，玩就送</div>
                </div>
              </div>
              <div class="baner-01-b">査看详情 ></div>
          </div>
       </div>
     </div>

     <div class="c-container">
       <div class="main">
         <div class="active-news">
           <div class="title" @click="toBack">
             <img src="@/assets/images/acd-back.png" >
             返回列表
           </div>

           <div>
						<div class="act-datail" v-if="type == 1">
							<h3>【六胡抢，湖南麻将，岳阳棋牌老版本迁移公告】</h3>
							<p>亲爱的闲逸牌友</p>
							<p>闲逸六胡抢，湖南麻将，岳阳棋牌将在2017年12月5日早晨8点关闭，更新至闲逸棋牌大厅，届时所有牌友的用户数据将全部迁移至闲逸棋牌。</p>
							<p>闲逸的列车正在全速前进中！伴随乔迁之喜，我们也进行了一系列的游戏调整，而本次调整还有许多的改动会陆续到来。首先，让我们捧出比赛系统（敬请期待），体验不一样的刺激，同时您在感受原有游戏之余，也可以体验其他不同种类的游戏，因此我们也必须谨慎，超级谨慎，满足各位闲逸牌友的需求同时也等不及想要看看各位牌友的各种心得分享了。</p>
							<p>在闲逸棋牌中，我们还增加了朋友局系统，并对一些bug进行修复，调整了游戏的乐趣。我们还根据玩家的反馈进行了一些调整。</p>
							<p>当然，我们并没有忘记闲逸棋牌的俱乐部---全新的俱乐部将在您这次迁徙中出现在您的视野里！请当心，当您使用俱乐部时，事情往往会出乎你的意料哦。</p>
							<p>祝您在闲逸棋牌好运连连。</p>
							<p class="t-right">
								<span>2017年12月7日</span>
								<span>闲逸官方</span>
							</p>
						</div>
						<div class="act-datail" v-if="type == 2">
							<h3>【闲逸棋牌俱乐部】升级牌桌显示，引爆玩牌氛围！</h3>
							<p style="color:red;">重大消息！重大消息！重大消息！</p>
							<p style="color:red;">闲逸棋牌全新俱乐部震撼上线！</p>
							<p>内容升级！操作简单！结合机器人使用更便捷！</p>
							<p>1.自由选桌，彻底解决离线不开始问题</p>
							<p>2.一键加入俱乐部，so easy！</p>
							<p>3.多包间切换，同一俱乐部支持五中玩法。</p>
							<p>4.强大俱乐部后台，支持每局游戏详细回访</p>
							<p>5.精致游戏画面，完美的游戏体验，随时随地感受棋牌室现场的氛围。</p>
							<p>这么厉害的俱乐部，是不是心动到不行？</p>
							<p>那就快来闲逸棋牌啊！</p>
							<p>因为只有我们的才有！</p>
						</div>
						<div class="act-datail" v-if="type == 3">
							<h3>【闲逸万圣节红包趴】</h3>
							<p>集合地点：闲逸麻将</p>
							<p>集合时间：11月1日，2日，每晚（21：00-22：00）不见不散。</p>
							<p>捣蛋姿势：</p>
							<p>1、打开闲逸棋牌——选择任意一款游戏。</p>
							<p>2、邀请亲朋好友加入游戏，玩上1局之后，就随机的出现红包雨！出现红包雨的游戏房间每个玩家都会有红包噢！</p>
							<p>3、如果遇见运财童子的玩家，可抓住了哦！有机会开出单个最高红包888元！</p>
							<p>活动注意：</p>
							<p>1、抢到红包的玩家们一定要先分享朋友圈，才可获得领取红包的资格噢！</p>
							<p>2、领取红包的玩家一定要先关注官方公众号：闲逸互娱，才可领取成功噢！</p>
							<p>3、在公众号闲逸互娱——活动中心——红包雨，玩家在游戏APP中抽到的红包会同步在公众号内的红包雨活动中更新。中奖玩家分享朋友圈获得领取资格，就可以在公众号内成功领取红包啦~</p>
						</div>
						<div class="act-datail" v-if="type == 4">
							<h3>【闲逸棋牌50万元现金红包大派送，"逸"起来看红包雨吧】</h3>
							<p>国庆遇见中秋，双节豪礼，天生一对。</p>
							<p>就如您遇上闲逸棋牌，激起千层火花，</p>
							<p>仿佛一下又双叒叕回到了三伏天，</p>
							<p>无处避暑？</p>
							<p>不如“逸"起来痛快的淋一场红包雨吧！</p>
							<p style="color:red;">两天总金额共计发出<b>50万元</b>现金红包！</p>
							<p>而且一个不小心就会碰到超萌的运财童子</p>
							<p>送出的无敌大红包哦~</p>
							<p style="color:red;">单个红包最高1888元！</p>
							<p style="color:red;">单个红包最高1888元！</p>
							<p style="color:red;">单个红包最高1888元！</p>
							<p style="color:red;">中奖概率超高，而且中奖机会也是不限制次数哦！</p>
							<p style="color:red;">玩的越多，碰到红包的机会就越多！</p>
							<p>★红包雨攻略</p>
							<p>★活动时间：10月3、4日（21：00-22：00）两天发出总金额共计50万元现金红包</p>
							<p>★活动坐标：地球上任何角落。</p>
							<p>★抢红包姿势：</p>
							<p>1、打开闲逸棋牌——选择任意一款游戏。</p>
							<p>2、邀请亲朋好友加入游戏，玩上1局之后，就随机的出现红包雨！出现红包雨的游戏房间每个玩家都会有红包噢！</p>
							<p>3、如果遇见运财童子的玩家，可抓住了哦！有机会开出单个最高红包1888元！</p>
							<p>★活动注意：</p>
							<p>1、抢到红包的玩家们一定要先分享朋友圈，才可获得领取红包的资格噢！</p>
							<p>2、领取红包的玩家一定要先关注官方公众号：闲逸互娱，才可领取成功噢！</p>
							<p>3、在公众号闲逸互娱——活动中心——红包雨，玩家在游戏APP中抽到的红包会同步在公众号内的红包雨活动中更新。中奖玩家分享朋友圈获得领取资格，就可以在公众号内成功领取红包啦~</p>
						</div>
						<div class="act-datail" v-if="type == 5">
							<h3>【株洲市首届闲逸麻将“红星美凯龙”杯线上挑战赛】</h3>
							<p>主办方：北京博久网络科技有限公司</p>
							<p>承办方：红星美凯龙株洲天元商场</p>
							<p>活动时间：2017年9月26日-10月6日</p>
							<p>活动流程：</p>
							<p>一、前期蓄客推广：</p>
							<p>1.制作网上报名通道，接受线上报名，设计发布活动H5进行转发推广；</p>
							<p>2.10月1日开始在神农广场LED大屏滚动播放活动宣传画面进行宣传造势；</p>
							<p>3.制作活动单页，举牌，蓄客期间每天安排人员外出人流较大老楼盘进行派发蓄客；</p>
							<p>4.商场内部自然客流进行活动宣导，接受线下报名；</p>
							<p>5.异业合作单位进行对点宣传蓄客。</p>
							<p>二、场次安排：</p>
							<p>比赛采取流水比赛制，时间为每天10：00-16：00</p>
							<p>1.初赛：9月26日-10月2日，共计7天规格按10桌/天X4人X4场/天=160人；预计初赛人数：160人X7天=1120人；</p>
							<p>2.复赛：9月3日-10月5日，初赛每桌取闲逸豆最多者进入复赛，人数：280人；场次：10桌/天X4人X3场/天=120人/天，前两天按满场次计算，复赛期间亦可接受线下报名，选出复赛选手进入第三天的复赛。</p>
							<p>3.决赛：10月6日，复赛每桌取闲逸豆最多者进入决赛，人数：70人，取闲逸豆获取前三名为：冠、亚、季军获得相应奖励并颁发奖杯与荣誉证书，前二十名获得礼品奖励并颁发荣誉证书，如遇有选手出现成绩相同情况，主办方需做好技术解释工作（如按点炮数，自摸数等进行排比）。</p>
							<p>三、人员安排：</p>
							<p>1.承办方负责招聘活动正常开展所需人员（签到处、统计处、裁判组等）；</p>
							<p>2.主办方负责提供技术支持及裁判组人员培训工作。</p>
							<p>四、比赛时间视线上报名情况而定，如未达到每天比赛所需人员数，比赛时间需整体往后延迟（整体结束不超过10月8号）。</p>
						</div>
					</div>

         </div>
         <div class="game-common">
           <div class="title">
             <img src="@/assets/images/a-title1.png" >
             <i class="reflush"></i>
           </div>

           <div class="game-icon">
             <div class="li" @click="toGames(item.type);" v-for="(item,index) in games" :key="index">
               <div class="l">
                 <img :src="item.icon" >
               </div>
               <div class="r">
                 <div class="tit">{{item.tit}}</div>
                 <div class="v">{{item.v}}</div>
               </div>
               <div class="arrow"></div>
             </div>
           </div>
         </div>
       </div>
     </div>

     <page-footer v-if="$route.meta.hasFooter"></page-footer>
   </div>
</template>
<script>
import Vue from 'vue'

export default {
  components: {
    pageFooter: () => import('@/components/footer'),
    pageHeader: () => import('@/components/layout/page-header')
  },
  data () {
    return {
     lists : [
       {
         name : '【六胡抢，湖南麻将，岳阳棋牌老版本迁移公告】',
         time : '2017/12/07',
         type : 1
       }
     ],
     games : [
       {
         icon : require('@/assets/images/ph-icon.png'),
         tit : '《闲逸碰碰》',
         v : 'v1.0.0版本',
         type : 2
       },
       {
         icon : require('@/assets/images/hz-icon.png'),
         tit : '《红中麻将》',
         v : 'v1.0.0版本',
         type : 3
       },
       {
         icon : require('@/assets/images/pkd-icon.png'),
         tit : '《跑得快》',
         v : 'v1.0.0版本',
         type : 6
       },
       {
         icon : require('@/assets/images/zz-icon.png'),
         tit : '《转转麻将》',
         v : 'v1.0.0版本',
         type : 4
       }
     ],
     type : 0,
    }
  },
  created () {
  },
  mounted () {
    let {type} = this.$route.query;

    this.type = type;
    console.log(type)
  },
  
  methods: {
    toNews(e){
      console.log(e)
    },
    toGames(e){
      let path = `/gameDetail?type=${e}`
      this.$router.push({
          path
      })
    },
    toBack(){
      this.$router.back()
    }
  }
}
</script>
<style lang="less" scoped>
.main{
  max-width: 512px;
  margin: 0 auto;
  position: relative;
}
.banners{
  height: 210px;
  background: url(../../assets/images/act-banner.jpg) no-repeat center;
  background-size: cover;

  .containt-div{
      max-width: 512px;
      position: relative;
      height: 300px;
      margin: 0 auto;
      padding-left: 10px;
      box-sizing: border-box;
      color: #fff;
  }

  .baner-01-a{
    padding-top: 110px;
    .tit{
      margin-bottom: 10px;
    }
    .txt{
      margin-bottom: 10px;
      span{
        padding-bottom: 4px;
        border-bottom: 1px solid #fff;
      }
    }
    .tags{
      span{
        margin-right: 10px;
      }
      margin-bottom: 40px;
    }
  }
  .baner-01-b{
    width: 110px;
    height: 26px;
    background: #fff;
    border-radius: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #b42ce3;
    cursor: pointer;
  }
}

.c-container{
	width: 100%;
	clear: all;
	overflow: hidden;
	background-image: url(../../assets/images/girl.png),url(../../assets/images/d-bg.png);
	background-position: left top, right bottom;
	background-repeat: no-repeat, no-repeat;
  padding-top: 15px;
  .main{
    display: flex;
    justify-content: space-between;
  }
  .active-news{
    width: 340px;
    .title{
      color: #e76e23;
      display: flex;
      align-items: center;
      cursor: pointer;
      img{
        width: auto;
        height: 12px;
        margin-right: 4px;
      }
    }
  }
  .game-common{
    width: 150px;
    .title{
      display: flex;
      justify-content: space-between;
      
      img{
        width: auto;
        height: 16px;
      }
      .reflush{
          width: 15px;
          height: 15px;
          background: url(../../assets/images/Refresh.png)no-repeat;
          background-size: cover;
          cursor: pointer;
      }
    }
    .game-icon{
      position: relative;
      width: 150px;
      background: #fff;
      border: 1px solid #ccc;
      margin-top: 10px;
      font-size: 8px;
      .li{
        width: 100%;
        height: 54px;
        border-bottom: 1px solid #ccc;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding-left: 10px;
        padding-right: 10px;
        cursor: pointer;
        
        .arrow{
          width: 12px;
          height: 12px;
          overflow: hidden;
          background: url(../../assets/images/a-arrow.png) no-repeat;
          background-size: auto 100%;
        }
        .l{
          width: 40px;
          height: 40px;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .r{
        }

        &:last-child{
          border: none;
        }
      }
    }
  }
}


.act-datail{
	color: #333;
	text-align: center;
	margin-top: 18px;
	padding-bottom: 20px;
}
.act-datail h3{
	color: #333;
	font-size: 10px;
}
.act-datail p{
	text-align: left;
    text-indent: 2em;
    font-size: 8px;
    margin: 10px;
    line-height: 12px;
}


@media (max-width:800px) {
  .c-container{
    .main{
      display: block;
    }
    .active-news , .game-common{
      width: 100%;
      padding: 0 10px;
      box-sizing: border-box;
    }
    .game-common{
      margin-top: 20px;
      margin-bottom: 20px;
      .game-icon{
        width: 100%;
        .li{
          justify-content: flex-start;
          .r{
            padding-left: 10px;
            width: 270px;
          }
        }
      }
    }
    
  }

  .act-datail h3{
    font-size: 14px;
  }
  .act-datail p{
      font-size: 12px;
      line-height: 16px;
  }
}


</style>
